<template>
    <div>

        <div class="row mt-5">
            <div class="col-sm-10">
                <!-- <b-button :href="$api_url+'/employee/export-bank-payment-template'" class="btn btn-primary rounded p-2 pr-4 pl-4 float-left"><b-icon icon="code-slash" ></b-icon> Download Template</b-button> -->
                 <!-- Abdullah26 added mr-2  -->
                <b-button @click="downloadTemplate(1)" class="btn btn-primary rounded float-left mr-2"><b-icon icon="code-slash" ></b-icon> Download Template For Active Employees</b-button>
                <b-button @click="downloadTemplate(0)" class="btn btn-primary rounded float-left mx-2"><b-icon icon="code-slash" ></b-icon> Download Template For Inactive Employees</b-button>
            </div>
            <div class="col-sm-2">
                <a :href="$api_url+'/employee'" class="btn btn-primary rounded p-2 pr-4 pl-4 float-right"><span><b-icon icon="reply" rotate="0" flip-h="" class="mr-2" scale="2"></b-icon></span><span>Back to List</span></a>
            </div>
        </div>

        <b-overlay :show="showoverlay" rounded="sm" class="mt-4">
            <b-form-file id="datafile" name="datafile" @change="uploadFile"  accept=".xlsx,.xls" ref="datafile"
            :state="validateState('datafile')" v-validate="{ mimes: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']}" aria-describedby="datafile-feedback">
        </b-form-file>
        <b-form-invalid-feedback id="datafile-feedback">{{ veeErrors.first('datafile') }}</b-form-invalid-feedback>
            <br />
        </b-overlay>

        <!-- Start: Rejwan: 12-02-2025 -->
        <ul class="list-group mb-3 " v-if='errormsg'>
            <li class="list-group-item list-group-item-danger" v-for="(data, index) in errormsg" :key="index">{{data}}</li>
        </ul>
        <!-- End: Rejwan: 12-02-2025 -->
  </div>
</template>
<script>

    export default{

        data(){
            return {

                showoverlay : false,
                errormsg:[], // Rejwan: 12-02-2025
            }
        },
        methods:{
            // Start: Rejwan: 10-02-2025
            downloadTemplate(f = 0)
            {
                let currentObj = this;
                let formData = new FormData();

                formData.append('employee_status', f);

                const config = {
                    headers: { 'Content-Type': 'application/json; charset=utf-8', },
                    responseType: 'blob',
                }
                axios.post(this.$api_url+'/employee/export-bank-payment', formData, config)
                    .then(function (response)
                    {
                        //this.showoverlay = false;

                        // var fileURL = response.data;

                        // this.downloadFileContent(fileURL);
                        if(response.data.type =='application/json'){
                                let file = new Blob([response.data], {type: 'application/json'}); /* if you use different error message just change the name instead of  'error_msg' */
                                const cast = Promise.resolve(file.text());
                                cast.then((value) => {
                                  let err_obj = JSON.parse(`${value}`);
                                  this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
                                });
                        }else{
                            this.global_download_file_content(response);
                        }

                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
            },
            // End: Rejwan: 10-02-2025
            uploadFile:function(event)
            {
                if(event.target.files[0])
                {
                    const file = event.target.files[0];
                    const allowedFileTypes = ['.xlsx'];
                    const extension = file.name.substr(file.name.lastIndexOf('.')).toLowerCase();
                    if (allowedFileTypes.includes(extension))
                    {

                    }
                    else
                    {
                        this.$refs.datafile.reset();
                        alert('Invalid file type.');
                        return false;
                    }
                }

                if(!this.checkNet()) return false;
                this.showoverlay = true;
                this.errormsg = [];
                this.employeesBankPaymentFile = event.target.files[0];

                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                const data = new FormData();
                data.append('employeesBankPaymentFile', this.employeesBankPaymentFile);

                axios.post(this.$api_url + '/employee/import-bank-payment/process', data , config).
                    then(function (response){
                        this.$bvToast.toast('Processing the data feed file.', {
                            title: `Job on progress`,
                            variant: 'info',
                            solid: true
                        });

                        if (response.data.success === true) {
                            this.showoverlay = false;
                            setTimeout("location.href = '"+this.$api_url+"/employee';",1500);
                        } else {
                            this.showoverlay = false;
                            //this.$bvToast.toast('Please correct the data and try again.', {
                               // title: `Data Template Error`,
                                //variant: 'danger',
                                //solid: true
                            //});

                            // Start: Rejwan: 12-02-2025
                            this.errormsg = response.data.errors;
                            this.$refs.datafile.value = "";
                	    this.employeesBankPaymentFile = null;
                            // setTimeout("location.href = '"+this.$api_url+"/employee/import-bank-payment';",5000);
                            // End: Rejwan: 12-02-2025
                        }

                    }.bind(this)).catch(function (error) {
                        this.showoverlay = false;
                        currentObj.$bvToast.toast('Please correct the data and try again.', {
                            title: `Data Template Error`,
                            variant: 'danger',
                            solid: true
                        });
                    });
            },
        },
    }
</script>
